import styled from "styled-components";
import { SPACING, QUERIES } from "../../utils/constants";

export const Container = styled.div`
  display: grid;
  grid-area: header;
  grid-template-areas:
    "headerTitle"
    "headerWrapper";
`;

export const Header = styled.div`
  grid-area: headerTitle;
  display: flex;
  flex-direction: column;
  padding: ${SPACING.md}px;
  gap: ${SPACING.sm}px;

  @media ${QUERIES.tabletAndUp} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${SPACING.xl}px;
    gap: ${SPACING.md}px;
  }
`;

export const HeaderWrapper = styled.div`
  grid-area: headerWrapper;
  border-bottom: 1px solid var(--color-light-gray-6);
  margin: 0 ${SPACING.md}px;
`;

export const HeaderTitle = styled.h1`
  font-size: var(--text-xxxl);
  font-weight: 600;
  color: var(--color-text-default);
  margin-bottom: ${SPACING.xs}px;
`;

export const SubHeaderTitle = styled.h3`
  font-size: var(--text-xl);
  font-weight: 600;
  color: var(--color-text-default);
  margin-bottom: ${SPACING.xxs}px;
`;

export const HeaderSubtitle = styled.p`
  font-size: var(--text-base);
  color: var(--color-text-secondary);
`;
